import React, { useRef, useState } from "react"
import "./Footer.css";

import 'firebase/compat/firestore';
import { firestore } from "../../firebase/firebase";
import { collection, serverTimestamp, addDoc} from "@firebase/firestore";

import {  Link } from "react-router-dom";

import {Avatar, Stepper, Step, Box, StepLabel, Button, Typography, StepContent, Paper, AppBar, Toolbar, IconButton, Accordion, AccordionSummary, AccordionDetails, Input } from "@mui/material";
import {  Card, Spinner, Row, Col, Form, Popover, OverlayTrigger, Offcanvas } from "react-bootstrap";

import logo from "../../images/logo.svg";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();

const Footer = () => {

  const [success, setSuccess] = useState(null);

  const emailRef = useRef();

  const AlertDismissable = () => {

    if (success === true) {
      
      return (
        <div>
          <h6 style={{ color: 'green' }}>
            {`Signed up, thanks!`}
          </h6>

        </div>
          
          
      );

    } else if (success === false) {

      return (
          <h6 style={{color: 'red'}}>Opps, something went wrong!</h6>
      );

    } else {

      return null;

    };
  
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const listRef = collection(firestore, `project watchlist`)

      await addDoc( listRef, {
        createdAt: serverTimestamp(),
        email: emailRef.current.value
        
      });
      
    } catch (error) {

      console.log(error.message);
      setSuccess(false);
      
    } finally {

      toast("Thanks for hanging around!")
      setSuccess(true);

    };

  };

  return (
    <div>
    <div style={{backgroundColor: '#1D1D41', padding: '5%'}}>
        <Row>
        <Col sm={8}>
          <h3 style={{color: "white", marginleft: '5%', textAlign: 'left', fontWeight: '900'}}>Lingo Loco</h3>
          <h6 style={{color: "white", marginleft: '5%'}}>The speech and listening focused platform <br/> for developing your language learning.</h6>
          {AlertDismissable()}
          </Col>
          <Col style={{marginTop: '1.5%'}}> 
          <Link to='/contact' style={{textDecoration: 'none', color: 'white'}}>Contact</Link> <br/>
          <Link to='/terms' style={{textDecoration: 'none', color: 'white'}}>terms and Condictions</Link><br/>
          <Link to='/privacy' style={{textDecoration: 'none', color: 'white'}}>Privacy Policy</Link><br/>
          </Col>
          <Col style={{marginTop: '1.5%'}}> 
          <Link to='/lessons' style={{textDecoration: 'none', color: 'white'}}>Lessons</Link><br/>
          <Link to='/levels' style={{textDecoration: 'none', color: 'white'}}>Levels</Link><br/>
          <Link to='/languages' style={{textDecoration: 'none', color: 'white'}}>Languages</Link><br/>
          </Col>
        </Row>
    </div>
    <Row style={{backgroundColor: '#1D1D41', color: "grey", padding: '1%'}}>
          <center>
            <p>Copyright ® 2023 Lingo Loco All rights Reserved.</p>
          </center>
        </Row>
    </div>
  );


  /*return (
    <div className="footer">
      <Row style={{marginLeft: '10%', marginRight: '10%'}}>
        <Col>
        <center>
        <h1 style={{color: 'White', margin: '7%'}}>
        Our platform isn't perfect, 
          <br /> we're only in beta.
        </h1>
        <p className="footer-text">
        Sign up to be notified of improvements and new level releases.
        </p>{" "}
        <Container maxWidth="md">
        <form onSubmit={handleSubmit} className="newsBox">
            <input type="email" className="newsInput" ref={emailRef}  placeholder="Enter your email" required/>
            <button type="submit" className="newsBtn">
              Submit
            </button>
          </form>
          {AlertDismissable()}
      </Container>
      </center>
        </Col>
        <Col>
        <img  style={{ margin: '20%'}} src={logoTwo} />
        </Col>
      </Row>
    </div>
  );*/
};

export default Footer;

